const UserAuthentication = {
  install(Vue) {
    Vue.prototype.$buildFormData = function (data, parentKey, formData = new FormData()) {
      if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
          this.$buildFormData(data[key], parentKey ? `${parentKey}[${key}]` : key, formData);
        });
      } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
      }
      return formData
    }
  }
};

export default UserAuthentication;
